import React from 'react';
import { useModal } from '@context/modal';
import { useParams } from '@context/params';

export function useModalSearchParams() {
  const { openModal } = useModal();
  const { modal, postCommentId, parentPostCommentId } = useParams();

  // We should only implement this feature on modals with primitive props
  // to avoid having to bloat the layout component with dependencies
  React.useEffect(() => {
    if (!modal) return;

    switch (modal) {
      default:
        break;
    }
  }, [modal, openModal, parentPostCommentId, postCommentId]);

  return null;
}
